import {
  SET_ENDERECO_PAIS,
  LOADING_ENDERECO_PAIS,
  ERROR_ENDERECO_PAIS,

  SET_ENDERECO_ESTADO,
  LOADING_ENDERECO_ESTADO,
  ERROR_ENDERECO_ESTADO,

  SET_ENDERECO_CEP,
  LOADING_ENDERECO_CEP,
  ERROR_ENDERECO_CEP,

  CHANGE_ENDERECO_VALUE_FORM,
  HANDLER_CHANGE_TYPEAHEAD,
  SET_ID_DDIPAIS_ENDERECO
} from './types';

const initialState = {
  typeaHeadEnderecoPaisList: [],
  loadingEnderecoPais: false,
  errorListEnderecoPais: null,

  typeaHeadEnderecoEstadoList: [],
  loadingEnderecoEstado: false,
  errorListEnderecoEstado: null,

  loadingEnderecoCEP: false,
  errorListEnderecoCEP: null,

  formEndereco: {
    endereco_cep: '',
    endereco_logradouro: '',
    endereco_numero: '',
    endereco_complemento: '',
    endereco_bairro: '',
    endereco_cidade: '',
    endereco_telefoneFixo: '',
    endereco_ddiTelefoneFixo: '55',
    endereco_provincia: ''
  },

  endereco_pais: 'BRA',
  endereco_estado: '',
  typeaHeadEnderecoEstadoDisabled: 'disabled',
  endereco_idDDDpais: null
}


export default function enderecoReducer(state = initialState, action) {
  switch (action.type) {

    case SET_ID_DDIPAIS_ENDERECO:
      return {...state, endereco_idDDDpais: action.payload}
    //Recebendo lista dos países para o typearead =====================================================
    case SET_ENDERECO_PAIS:
      return { ...state, typeaHeadEnderecoPaisList: action.payload }

    case LOADING_ENDERECO_PAIS:
      return { ...state, loadingEnderecoPais: action.payload }

    case ERROR_ENDERECO_PAIS:
      return { ...state, errorListEnderecoPais: action.payload }

    //Recebendo lista dos estados para o typearead ===============================================
    case SET_ENDERECO_ESTADO:
      return { ...state, typeaHeadEnderecoEstadoList: action.payload }

    case LOADING_ENDERECO_ESTADO:
      return { ...state, loadingEnderecoEstado: action.payload }

    case ERROR_ENDERECO_ESTADO:
      return { ...state, errorListEnderecoEstado: action.payload }

    //Recebendo objeto com as informacções de endereço do CEP para o form ===============================================
    case SET_ENDERECO_CEP:
      return { ...state, formEndereco: action.payload }

    case LOADING_ENDERECO_CEP:
      return { ...state, loadingEnderecoCEP: action.payload }

    case ERROR_ENDERECO_CEP:
      return { ...state, errorListEnderecoCEP: action.payload }


    //Adicionando valores dos forms as variáveis do reduce ======================================
    case CHANGE_ENDERECO_VALUE_FORM:
      return { ...state, formEndereco: action.payload }

    //Adicionando o valor do typeahead país a variável===================================================
    case HANDLER_CHANGE_TYPEAHEAD:
    let {value, name} = action.payload;
    let newState = {...state};
    newState[name] = value  
    
    return newState;

    default:
      return state
  }
}